function CancelStatusItem() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" fill="#EBEBEB"/>
      <circle cx="12" cy="12" r="11.25" fill="#FFF0C9" stroke="#B36500" strokeWidth="1.5"/>
      <path d="M11 7H12.9955V13.6554H11V7ZM11 14.7601H12.9955V16.9773H11V14.7601Z" fill="#B36500"/>
      <rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="#B36500" strokeWidth="1.5"/>
    </svg>
  )
}

export default CancelStatusItem